/**
 * Definizione dell' interfaccia e della classe ComuneRecord, la struttura dati che rappresenta un comune italiano.
 */
import {FPNetDate, ObjectFactory} from "@commons/types";
import {ProvinciaRecord} from "./ProvinciaRecord";

export interface ComuneRecord {
    cap: number | null,
    codComune: string | null, // codice catasto, es. F704
    descrizione: string | null,
    inizioValidita: FPNetDate,
    fineValidita: FPNetDate,
    provincia: Partial<ProvinciaRecord> | null,
    siglaProv: string | null,
}

export class ComuneRecord {
    static factory: ObjectFactory<ComuneRecord> = (json?) => {
        return {
            cap: (json && json.cap) ? json.cap : null,
            codComune: (json && json.codComune) ? json.codComune : null,
            descrizione: (json && json.descrizione) ? json.descrizione : null,
            inizioValidita: null,
            fineValidita: null,
            provincia: (json && json.provincia) ? json.provincia : null,
            siglaProv: (json && json.siglaProv) ? json.siglaProv : null,
        };
    }
}